
import { Component, Prop, Vue } from "vue-property-decorator";
import { SMQuestionnaire } from "@/store";

@Component
export default class QuestionnaireProgress extends Vue {
  @Prop({ type: Number, required: true }) readonly number!: number;

  get filledBarStyle() {
    return { width: `${this.number}%` };
  }

  get numberClass() {
    return { "questionnaire-progress__number_filled": this.number > 0 };
  }

  get isEditingFlow() {
    return SMQuestionnaire.display_name === "Data editing";
  }
}
